import type { IconData } from '@stacksjs/iconify-core'

export const grids: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M23 21V3a1 1 0 0 0-1-1h-5v20h5a1 1 0 0 0 1-1\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M1 3v18a1 1 0 0 0 1 1h5V2H2a1 1 0 0 0-1 1\"/><path fill=\"currentColor\" d=\"M9 2h6v20H9z\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M7 2h2v20H7zm8 0h2v20h-2z\" opacity=\".25\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default grids
